import { createContext, useContext, useEffect, useState } from 'react'
import { sendPasswordResetEmail, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { auth, getUserInfo } from '../services/firebase/firebase'

const AuthContext = createContext({
    currentUser: null,
    login: () => Promise,
    logout: () => Promise,
    forgotPassword: () => Promise,
})

export const useAuth = () => useContext(AuthContext)

export default function AuthContextProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null)
    const [userInfo, setUserInfo] = useState(null)

    function login(email, password) {
        return signInWithEmailAndPassword(auth, email, password)
    }

    function forgotPassword(email) {
        return sendPasswordResetEmail(auth, email, {
            url: 'http://localhost:3000'
        })
    }

    function logout() {
        return signOut(auth)
    }

    const value = {
        currentUser,
        setCurrentUser,
        userInfo,
        login,
        logout,
        forgotPassword
    }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(setCurrentUser)
        return unsubscribe;
    }, [])

    useEffect(() => {
        if (!currentUser?.uid) return
        getUserInfo(currentUser.uid)
            .then((info) => setUserInfo(info))
    }, [currentUser])

    return <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
}